export enum ScreenerView {
  TYPEFORM = "typeform",
  TYPEFORM_SUBMISSION = "typeformSubmission",
  LOADING_TYPEFORM_SUBMISSION = "loadingTypeformSubmission",
  SAVING_RESPONSES = "savingResponses",
  INSURANCE_ELIGIBILITY = "insuranceEligibility",
  PASSWORD_INPUT = "passwordInput",
  VERIFICATION_PENDING = "verificationPending",
  COVERAGE_RESULT = "coverageResult",
  TWO_FACTOR_AUTH = "twoFactorAuth",
  SCHEDULE_CONSULT = "scheduleConsult",
  CONSULT_BOOKED = "consultBooked",
  INTAKE_CONFIRMATION = "intakeConfirmation",
  LOADING_ACCOUNT_CREATION = "loadingAccountCreation",
  NEXT_STEPS = "nextSteps",
  DIRECT_INTAKE_REQUESTED = "directIntakeRequested",
  PROVIDER_SELECTION = "providerSelection",
  ADD_INSURANCE_CARD = "addInsuranceCard",
  INSURANCE_CARD_UPLOAD = "insuranceCardUpload",
  CARE_TEAM_FOLLOW_UP = "careTeamFollowUp"
}

export type CareScreenerData = {
  id: number;
  typeformId: string;
  typeformResponseId: string;
  path: string;
  email: string;
  phoneNumber: string;
  schedulingQueryStartDate?: string;
  createdAt: string;
};
